import React, { useState } from "react";
import ExpandableSearchDropdown2 from "../../components/ExpandableSearchDropdown2";
import FiltersPanel from "./FiltersPanel";
import { Filter } from "lucide-react";

const FilterRowStudentsSupports = ({
  state,
  userRole,
  updateState,
  filterCount,
  onStudentClick,
  removeSelectedStudent,
  initialSearchTerm,
  autoSelectStudentEmail,
  filteredStudentsCount,
  isModalOpen,
  user,
}) => {
  const [filtersOpen, setFiltersOpen] = useState(false);

  return (
    <div className={`flex sm:gap-3 w-full items-center ${isModalOpen ? "sm:flex-col 2xl:flex-row" : "flex-row"}`}>
      <div className={`flex flex-col w-[100%] ${isModalOpen ? "sm:w-full 2xl:w-2/3" : "sm:w-2/3"} text-400`}>
        <ExpandableSearchDropdown2
          state={state}
          userRole={userRole}
          updateState={updateState}
          onStudentClick={onStudentClick}
          removeSelectedStudent={removeSelectedStudent}
          initialSearchTerm={initialSearchTerm}
          autoSelectStudentEmail={autoSelectStudentEmail}
          isModalOpen={isModalOpen}
          user={user}
          analyticsScope="student_supports"
        />
      </div>
      <div className={`hidden sm:flex sm:flex-col ${isModalOpen ? "sm:w-full 2xl:w-1/3" : "sm:w-1/3"}`}>
        <button
          className="flex items-center gap-2 p-2 text-400 text-base border border-[#DDDDDD] rounded"
          onClick={() => setFiltersOpen(true)}
          data-onboarding-id="student-supports-filters"
          data-analytics-id="open_filters"
          data-analytics-label="Open filters"
        >
          <span>
            <Filter className="w-4 h-4 text-gray-600" />
          </span>
          Filters
          <span className="rounded-full bg-[#1879EE] text-white text-sm px-2 font-semibold">
            {filterCount > 0 && <span className="">{filterCount}</span>}
          </span>
        </button>
        <FiltersPanel
          isOpen={filtersOpen}
          onClose={() => setFiltersOpen(false)}
          state={state}
          updateState={updateState}
          filteredStudentsCount={filteredStudentsCount}
        />
      </div>
    </div>
  );
};

export default FilterRowStudentsSupports;
